import { InjectionToken } from '@angular/core';

/**
 * Api base url for MaintenanceAssistant user settings
 */
export const US_BASE_URL = new InjectionToken('User settings Base Url');
